import { useAuthContext } from '../../contexts/AuthContext';
import { useUser } from '../../hooks/useUser';
import { Typography, Avatar, Paper, Button, Divider } from '@mui/material';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

export default function ProfilePage() {
  const { user, signOut } = useAuthContext();
  const { userDoc } = useUser(user);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <Paper elevation={3} className="p-6 rounded-xl bg-white">
        <div className="flex flex-col items-center mb-8">
          <div className="relative">
            <Avatar
              sx={{
                width: 120,
                height: 120,
                bgcolor: 'primary.main',
                mb: 3,
                border: '4px solid',
                borderColor: 'primary.light',
              }}
            >
              <UserCircleIcon className="h-20 w-20" />
            </Avatar>
          </div>
          
          <Typography variant="h4" component="h1" className="text-center mb-2 font-bold text-gray-800">
            {userDoc?.displayName || 'Utilisateur'}
          </Typography>
          
          <Typography variant="body1" color="text.secondary" className="mb-4">
            {user?.email}
          </Typography>
          
          <div className="flex items-center space-x-2 bg-blue-50 px-4 py-2 rounded-full">
            <span className="text-sm font-medium text-blue-700">
              {userDoc?.role === 'admin' ? 'Administrateur' : 
               userDoc?.role === 'coach' ? 'Entraîneur' : 
               userDoc?.role === 'parent' ? 'Parent' : 'Joueur'}
            </span>
          </div>
        </div>

        <Divider className="my-6" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-white p-4 rounded-lg shadow">
            <Typography variant="h6" className="font-semibold mb-3 text-gray-700">
              Informations personnelles
            </Typography>
            <div className="space-y-2">
              <div>
                <Typography variant="caption" className="text-gray-500 block">Nom complet</Typography>
                <Typography>{userDoc?.displayName || 'Non défini'}</Typography>
              </div>
              <div>
                <Typography variant="caption" className="text-gray-500 block">Email</Typography>
                <Typography>{user?.email || 'Non défini'}</Typography>
              </div>
              <div>
                <Typography variant="caption" className="text-gray-500 block">Statut</Typography>
                <Typography>{userDoc?.status || 'Actif'}</Typography>
              </div>
            </div>
          </div>

          <div className="bg-white p-4 rounded-lg shadow">
            <Typography variant="h6" className="font-semibold mb-3 text-gray-700">
              Paramètres du compte
            </Typography>
            <div className="space-y-3">
              <Button 
                variant="outlined" 
                fullWidth 
                onClick={() => navigate('/profil/modifier')}
              >
                Modifier le profil
              </Button>
              <Button 
                variant="outlined" 
                color="secondary" 
                fullWidth
                onClick={() => navigate('/profil/mot-de-passe')}
              >
                Changer le mot de passe
              </Button>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-8">
          <Button 
            variant="contained" 
            color="error"
            onClick={handleSignOut}
            startIcon={
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
              </svg>
            }
          >
            Se déconnecter
          </Button>
        </div>
      </Paper>
    </div>
  );
}
